import Comm from '../services/comm';

export default{
    namespaced: true,
    state: {
        loading: false,
        getClientLoading: false,
        editClientLoading: false,
        error: null
    },
    actions: {
        getClientList(context, data){
            context.state.error = null;
            context.state.loading = true;
            let params = {
                filter: data.filter,
                order: data.order
            };
            Comm.postData('clients.php', params).then(
                res => {
                    data.result(res);
                    context.state.loading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.loading = false;
                }
            )
        },
        getClient(context, data){
            context.state.error = null;
            context.state.getClientLoading = true;
            Comm.getData(`client.php?id=${data.id}`).then(
                res => {
                    if(res.data.status == 'ok'){
                        data.result(res);
                    } else {
                        context.error = 'Hiba történt betöltés közben, kérem forduljon a rendszergazdához!';
                        data.reject(res);
                    }
                    context.state.getClientLoading = false;
                },
                rej => {
                    context.error = 'Hiba történt betöltés közben, kérem forduljon a rendszergazdához!';
                    data.reject(rej);
                    context.state.getClientLoading = false;
                }
            );
        },
        saveClient(context, data){
            context.state.error = null;
            context.state.loading = true;
            Comm.postData('client.php', {data: data.data}).then(
                res => {
                    if(res.data.status == 'ok'){
                        data.result(res);
                    } else {
                        context.error = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                        data.reject(res);
                    }
                    context.state.loading = false;
                },
                rej => {
                    context.error = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                    data.reject(rej);
                    context.state.loading = false;
                }
            )
        },
        editClient(context, data){
            context.state.error = null;
            context.state.editClientLoading = true;
            Comm.putData('client.php', {data: data.data, conditions: {id: ['=', data.data.id]}}).then(
                res => {
                    if(res.data.status == 'ok'){
                        data.result(res);
                    } else {
                        context.error = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                        data.reject(res);
                    }
                    context.state.editClientLoading = false;
                },
                rej => {
                    context.error = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                    data.reject(rej);
                    context.state.editClientLoading = false;
                }
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/clientStore.js